import { Route, Routes } from "react-router-dom";
import { ROUTEPATHS } from "../../libs";
import { ManagePackagesContainer } from "./manage-packages";
import { ManageUsersContainer } from "./manage-users";
import { ManagePublicPlansContainer } from "./manage-public-plans";
import { ContactInquiriesContainer } from "./contact-inquiries";

export const RouteAdminContainer: React.FC = () => {
  return (
    <Routes>
      <Route path={`/${ROUTEPATHS.MANAGE_USERS}`} element={<ManageUsersContainer />} />
      <Route path={`/${ROUTEPATHS.MANAGE_PACKAGES}`} element={<ManagePackagesContainer />} />
      <Route path={`/${ROUTEPATHS.MANAGE_PUBLIC_PLANS}`} element={<ManagePublicPlansContainer />} />
      <Route path={`/${ROUTEPATHS.CONTACT_INQUIRIES}`} element={<ContactInquiriesContainer />} />
    </Routes>
  );
};
